// extracted by mini-css-extract-plugin
export default {"MuiAutocomplete-option":"src_MuiAutocomplete-option__h0GAu","MuiAutocomplete-listbox":"src_MuiAutocomplete-listbox__OGFwm","jinniBotBody":"src_jinniBotBody__vcuno"};